import { render, staticRenderFns } from "./KintsuLogoIcon.vue?vue&type=template&id=28976bed&scoped=true&"
import script from "./KintsuLogoIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./KintsuLogoIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28976bed",
  null
  
)

export default component.exports